export const tr = {
    'continue-edit': 'Düzenlemeye devam et',
    'default-name': 'Yeni grup',
    ok: 'OK',
    'previews-title': 'Kreatif önizleme',
    'reset-smart-center': "Akıllı Merkez'i kur",
    'show-all-previews': 'Tümünü göster'
};
